import { InsertionPosition } from "@redotech/redo-storefront-common/insertion-position";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const hsaPdpWidgetPlacementSchema_ = z.object({
  cssSelector: z.string(),
  insertionPosition: createEnum(InsertionPosition, {
    enumName: "InsertionPosition",
  }).optional(),
});

/** Where the "Pay with HSA/FSA" eligibility widget is placed on the storefront
 * product page. Mirrors the `settings.hsa.pdpWidgetPlacement` Mongoose subdoc. */
export const hsaPdpWidgetPlacementSchema: z.ZodType<HsaPdpWidgetPlacement> =
  hsaPdpWidgetPlacementSchema_;
export interface HsaPdpWidgetPlacement extends z.infer<
  typeof hsaPdpWidgetPlacementSchema_
> {}

const hsaCartWidgetPlacementSchema_ = z.object({
  selector: z.string(),
  insertPosition: createEnum(InsertionPosition, {
    enumName: "InsertionPosition",
  }),
});

/** One placement of the HSA/FSA cart eligibility widget on the storefront cart
 * (cart page or slide-in drawer). Mirrors one entry of the
 * `settings.hsa.cartWidgetPlacements` Mongoose subdoc array. */
export const hsaCartWidgetPlacementSchema: z.ZodType<HsaCartWidgetPlacement> =
  hsaCartWidgetPlacementSchema_;
export interface HsaCartWidgetPlacement extends z.infer<
  typeof hsaCartWidgetPlacementSchema_
> {}
